import { render, staticRenderFns } from "./AddNewUser.vue?vue&type=template&id=613d76bf"
import script from "./AddNewUser.vue?vue&type=script&lang=js"
export * from "./AddNewUser.vue?vue&type=script&lang=js"
import style0 from "./AddNewUser.vue?vue&type=style&index=0&id=613d76bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports